/* eslint-disable no-console */
import Abbreviation from '@react/Abbreviation'

import { DynamicFieldType, ItemType } from '../../FilterableListTypes'

type FragmentListTableDataPropsType = {
  dynamicField: DynamicFieldType
  componentName: string
  item: ItemType
}

const isInternalLink = (url: string): boolean => {
  if (!url) return false;
  try {
    const link = new URL(url, window.location.origin);
    return link.hostname === window.location.hostname || url.startsWith('/');
  } catch {
    return url.startsWith('/');
  }
};

// Append `.html` to internal links if missing
const getResolvedLink = (url: string): string => {
  if (!url) return '#';
  if (isInternalLink(url)) {
    return url.endsWith('.html') ? url : `${url}.html`;
  }
  return url;
};

const abbrStringMaxLength = 90
const abbrMaxItemsAsArray = 3

export const FragmentsListTableData = ({ dynamicField, componentName, item }: FragmentListTableDataPropsType) => {

  const renderLink = (dynamicField: DynamicFieldType) => {
  const linkUrl = dynamicField.key === 'csafLink' ? item.csafLink : item.link;

  const resolvedUrl = getResolvedLink(linkUrl);
  const internal = isInternalLink(linkUrl);

  const linkText =
    dynamicField.key === 'csafLink' ? (
      <span className="cmp-button__icon cmp-button__icon--download"></span>
    ) : (
      item?.title || item?.fileName || item?.pageName || linkUrl
    );

  return (
     <a
      href={resolvedUrl}
      className="cmp-filterable-list__list-link"
      target={internal ? '_self' : '_blank'}
      rel={internal ? undefined : 'noopener noreferrer'}
      data-dm={`${componentName}.link`}
    >
      {linkText}
    </a>
  );
};

  const renderFieldArrayAsAbbreviation = (item: ItemType, dynamicField: DynamicFieldType) => {
    const displayedItems = item[dynamicField.key].slice(0, abbrMaxItemsAsArray)

    if (item[dynamicField.key].length > abbrMaxItemsAsArray) {
      const value = displayedItems.join('/')
      const title = item[dynamicField.key].join('/')
      return <Abbreviation title={title} value={value} isArray={'true'} abbrString={'...'} toolTipType={'tooltip'} />
    } else {
      return displayedItems.map((item, index) => <div key={index}>{item}</div>)
    }
  }

  if (dynamicField.link || dynamicField.key === 'csafLink') {
    return renderLink(dynamicField)
  } else if (Array.isArray(item[dynamicField.key]) && item[dynamicField.key].length > 1) {
    return renderFieldArrayAsAbbreviation(item, dynamicField)
  } else if (item[dynamicField.key]?.length > abbrStringMaxLength) {
    return (
      <Abbreviation
        title={item[dynamicField.key]}
        value={item[dynamicField.key].slice(0, abbrStringMaxLength).trim()}
        abbrString={'...'}
        toolTipType={'tooltip'}
      />
    )
  } else {
    return item[dynamicField.key]
  }
}
